import { z } from 'zod';
import { LEVELS, ROLES, CATEGORIES, define, DEFINITION_KINDS } from '../types.js';

/**
 * Default delivery workflow ID.
 */
export const schema = z.number().int().positive();

export type DefaultDeliveryWorkflowId = z.infer<typeof schema>;

export const definition = define({
  key: 'default_delivery_workflow_id',
  schema,
  label: 'Default Delivery Workflow ID',
  description: 'Default delivery workflow ID. Auto-populated from workflowset selection.',
  kind: DEFINITION_KINDS.SETTING,
  category: CATEGORIES.WORKFLOWS.key,
  writableAtLevels: [LEVELS.HOPDRIVE, LEVELS.CUSTOMER],
  readableByRoles: [ROLES.ADMIN],
  defaultValue: 2,
});
